import React from "react";
import { chevronLeft, chevronRight } from "./SVG";

export default function PaginationDiscovery(props) {
  console.log(props);
  const pageGroupSize = 12;
  const currentGroup = Math.floor((props.currentPage - 1) / pageGroupSize);
  const startPage = currentGroup * pageGroupSize + 1;
  const endPage = Math.min(startPage + pageGroupSize - 1, props.totalPages);
  const pagesToDisplay = [];

  for (let i = startPage; i <= endPage; i++) {
    pagesToDisplay.push(i);
  }

  const onPaginate = (page) => {
    props.onPaginate(page);
  };
  return (
    <div className="pagination">
      <p>{`Viewing ${
        props.currentPage === 1
          ? 1
          : (props.currentPage - 1) * props.perPage + 1
      }-${
        props.total > props.currentPage * props.perPage
          ? props.currentPage * props.perPage
          : props.total
      } of ${props.total}`}</p>
      <ul>
        <li className="prev">
          <button
            className={props.currentPage === 1 ? "disabled" : ""}
            onClick={() => onPaginate(Math.max(props.currentPage - 1, 1))}
          >
            {chevronLeft}
          </button>
        </li>

        {pagesToDisplay.map((i) => {
          let className =
            props.currentPage === i ? "number selected" : "number";
          return (
            <li key={i}>
              <button className={className} onClick={() => onPaginate(i)}>
                {i}
              </button>
            </li>
          );
        })}

        <li className="next">
          <button
            className={props.currentPage === props.totalPages ? "disabled" : ""}
            onClick={() =>
              onPaginate(
                props.currentPage === props.totalPages
                  ? props.currentPage
                  : props.currentPage + 1
              )
            }
          >
            {chevronRight}
          </button>
        </li>
      </ul>
    </div>
  );
}
